<script setup>
import { computed } from 'vue';

const props = defineProps({
  conversation: { type: Object, default: null },
});

const isClosed = computed(() => props.conversation?.can_reply === false);
</script>

<template>
  <span
    v-if="isClosed"
    v-tooltip="'Ventana 24h cerrada'"
    class="text-xs"
    style="color: rgb(234, 179, 8);"
  >⏳</span>
</template>
